// @libs
import PropTypes from "prop-types";
// @mui-material
import DeleteIcon from "@material-ui/icons/Delete";
//import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { IconButton  as MuiIconButton, Tooltip } from "@material-ui/core";

//import { IconButton as MuiIconButton, Tooltip } from "@mui/material";

const DeleteIconButton = ({
  title = "Eliminar",
  customIcon = null,
  onClick,
  ...props
}) => {
  return (
    <Tooltip title={title}>
      <MuiIconButton
        onClick={onClick}
        aria-label={title}
        color="error"
        size="small"
        sx={{
          transition: "transform 0.2s ease",
          "&:hover": {
            backgroundColor: "rgba(244, 67, 54, 0.1)", // error.main with opacity
            transform: "scale(1.1)",
          },
        }}
        {...props}
      >
        {customIcon || <DeleteIcon fontSize="small" />}
      </MuiIconButton>
    </Tooltip>
  );
};

DeleteIconButton.propTypes = {
  title: PropTypes.string,
  customIcon: PropTypes.node,
  onClick: PropTypes.func,
};

export default DeleteIconButton;
